import './alert.scss';

import { AlertSuccessIcon, AlertWarningIcon, Heading } from '@ctct/payflow-ui';

export type AlertVariant = 'warning' | 'success';

interface Props {
  header?: string;
  message: React.ReactNode;
  variant?: AlertVariant;
}

export const Alert = ({ variant = 'warning', message, header }: Props) => {
  return (
    <div className={`payflow-presentation alert-container variant-${variant}`}>
      <div className="alert-icon">
        {variant === 'warning' && <AlertWarningIcon />}
        {variant === 'success' && <AlertSuccessIcon />}
      </div>
      <div className="alert-body">
        {header && (
          <Heading level="h6" className="alert-header">
            {header}
          </Heading>
        )}
        <span className="alert-message">{message}</span>
      </div>
    </div>
  );
};
